import { useState } from "react";
import { Button } from "components/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "components/ui/dialog";
import { useTranslation } from "react-i18next";
import { ModalIcon } from "components/modal/ModalIcon";
import { useDialog } from "hooks/useDialog";
import { useOrganisation } from "contexts/OrganisationProvider";
import { AddOrganisationMemberForm } from "./AddOrganisationMemberForm";

export const AddOrganisationMemberModal = () => {
  const { t } = useTranslation(["settings"]);
  const { organisation } = useOrganisation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const isDeletedOrg = !!organisation?.deletedAt;
  const dialog = useDialog("add-organisation-member");

  const handleFormSubmitting = (submitting: boolean) => {
    setIsSubmitting(submitting);
  };

  return (
    <Dialog open={dialog.isOpen} onOpenChange={dialog.onOpenChange}>
      <DialogTrigger asChild>
        <Button
          label={t("settings:organisation.members.add.button")}
          icon="plus"
          className="py-2 font-normal"
          disabled={isDeletedOrg}
        />
      </DialogTrigger>

      <DialogContent className="overflow-visible">
        <DialogHeader className="mb-6 items-center">
          <ModalIcon
            icon="user"
            className="bg-primary-100/75 mb-4 mt-4 ring-8 ring-primary-100/75"
            pulse={false}
            iconClassName="text-primary-700"
          />

          <DialogTitle className="">
            {t("settings:organisation.members.add.modal.title")}
          </DialogTitle>
          <DialogDescription className="">
            {t("settings:organisation.members.add.modal.description")}
          </DialogDescription>
        </DialogHeader>

        <AddOrganisationMemberForm
          onClose={() => dialog.close()}
          onSubmitting={handleFormSubmitting}
          onValidationErrors={setHasValidationErrors}
        />

        <DialogFooter>
          <DialogClose asChild>
            <Button
              label={t(
                "settings:organisation.members.add.modal.actions.cancel",
              )}
              variant="tertiary"
              size="small"
              disabled={isSubmitting}
            />
          </DialogClose>
          <Button
            type="submit"
            form="add-organisation-members"
            label={t("settings:organisation.members.add.modal.actions.add", {
              count: 1,
            })}
            size="small"
            icon={isSubmitting ? "loader" : "plus"}
            iconClassName={isSubmitting ? "animate-spin" : undefined}
            disabled={isSubmitting || hasValidationErrors}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
